import React from "react";
import BannerNew from "../BannerNew/index.jsx";
import AboutUsSection from "../../components/CommonComponents/AboutUsSection/index.jsx";
import HowItWorksSection from "../../components/CommonComponents/HowItWorksSection/index.jsx";
import InventoryPaymentSetupSection from "../../components/CommonComponents/InventoryPaymentSetupSection/index.jsx";

const MultipleAccordions = () => {
  return (
    <>
      <BannerNew />
      <AboutUsSection setIsFaqVisible={false} isCustomerSupport={false} isPublic={true}/>
      <HowItWorksSection />
      <InventoryPaymentSetupSection />
    </>
  );
};

export default MultipleAccordions;
